/**
 * modul komunikacji z natywną aplikacją
 * @module nativeApp
 */
app.service('nativeApp', function () {

	/**
 	* @function
 	* wysyła wiadomość do natywnej aplikacji
	* @param {object} options obiekt z parametrami wiadomości
	*/
	function postMessage(options){
		window.mobileApp?.postMessage({ detail: options });
	}

	/**
 	* @function
 	* ustawia nasłuchiwanie wiadomości od natywnej aplikacji
	* @param {function} callback funkcja wywoływana po otrzymaniu wiadomości
	*/
	function setEventListener(callback) {
		window.addEventListener('messageFromNative', (event) => {
			callback(event.detail);
		});
	}

	return {
		postMessage,
		setEventListener
	};
});
